import { FiXCircle, FiTrash2, FiEdit2, FiCheckCircle, FiMapPin } from 'react-icons/fi'
import { MdOutlineAddTask } from 'react-icons/md'
import { FaFileCirclePlus } from 'react-icons/fa6'
import { IoIosSave } from 'react-icons/io'
import './Button.css'

const VARIANTS = {
    save:   { cls: 'btn-flat btn-flat-save',   Icon: IoIosSave },
    new:    { cls: 'btn-flat btn-flat-new',    Icon: FaFileCirclePlus },
    cancel: { cls: 'btn-flat btn-flat-cancel', Icon: FiXCircle },
    delete: { cls: 'btn-flat btn-flat-delete', Icon: FiTrash2 },
    edit:   { cls: 'btn-flat btn-flat-edit',   Icon: FiEdit2 },
    finish: { cls: 'btn-flat btn-flat-finish', Icon: FiCheckCircle },
    select: { cls: 'btn-flat btn-flat-select', Icon: MdOutlineAddTask },
    map:    { cls: 'btn-flat btn-flat-map',    Icon: FiMapPin },
}

const labelStyle = {
    fontSize: '8px',
    fontWeight: 800,
    fontFamily: "'Nunito', sans-serif",
    letterSpacing: '0.4px',
    lineHeight: 1,
    textTransform: 'uppercase',
}

function Button({ variant = 'save', type = 'button', onClick, children, className, style, icon: IconOverride, disabled }) {
    const { cls, Icon, iconSize = 24 } = VARIANTS[variant] || VARIANTS.save
    const FinalIcon = IconOverride || Icon
    return (
        <button
            type={type}
            className={`shd-bt-m-1 ${cls} ${className || ''}`}
            style={{
                flexDirection: 'column',
                gap: '5px',
                padding: '10px 20px',
                width: '80px',
                margin: 0,
                ...style,
            }}
            onClick={onClick}
            disabled={disabled}
        >
            <span className="btn-icon"><FinalIcon size={iconSize} /></span>
            <span style={labelStyle}>{children}</span>
        </button>
    )
}

export default Button
